module.exports = __webpack_public_path__ + "img/25.1567ae8b.jpg";